// extracted by mini-css-extract-plugin
export default {"wrapper":"CostToBusiness-module__wrapper___fC4S4","permissions":"CostToBusiness-module__permissions___VPtta","roleCostContainer":"CostToBusiness-module__roleCostContainer___SAPvk"};